module.exports = __webpack_public_path__ + "./fonts/GalanoGrotesque-Medium.ttf";